/* ============================================================
 * NauticIQ pricing calculator — reads Base360 table + cockpit
 * meta from data-nq-catalog (billing DB). Fallback constants
 * only when catalog is missing.
 * ============================================================ */

(function () {
  'use strict';

  var FALLBACK_COCKPIT_MONTHLY = 20;
  var FALLBACK_FREE_MONTHS = 2;
  var FALLBACK_ENTERPRISE_THRESHOLD = 40;
  var FIRST_YEAR_OFF = 0.5;
  var FALLBACK_PRICE_TABLE = [
    [1, 500, 500], [2, 250, 500], [3, 166, 500], [4, 125, 500], [5, 100, 500],
    [6, 99, 594], [7, 92, 644], [8, 86, 688], [9, 81, 729], [10, 76, 760],
    [11, 72, 792], [12, 68, 816], [13, 65, 845], [14, 62, 868], [15, 59, 885],
    [16, 57, 912], [17, 54, 918], [18, 52, 936], [19, 49, 931], [20, 47, 940],
    [21, 45, 945], [22, 44, 968], [23, 43, 989], [24, 42, 1008], [25, 41, 1025],
    [26, 41, 1066], [27, 40, 1080], [28, 40, 1120], [29, 40, 1160], [30, 40, 1200],
    [31, 39, 1209], [32, 39, 1248], [33, 38, 1254], [34, 37, 1258], [35, 37, 1295],
    [36, 36, 1296], [37, 36, 1332], [38, 35, 1330], [39, 35, 1365], [40, 35, 1400]
  ];

  function parseCatalog(section) {
    var raw = section.getAttribute('data-nq-catalog');
    if (!raw) {
      return null;
    }
    try {
      return JSON.parse(raw);
    } catch (e) {
      return null;
    }
  }

  function buildConfig(catalog) {
    var base = catalog && catalog.base360 ? catalog.base360 : null;
    var meta = (base && base.meta) ? base.meta : {};
    var table = [];
    if (base && Array.isArray(base.table) && base.table.length) {
      for (var i = 0; i < base.table.length; i++) {
        var row = base.table[i];
        table.push([
          parseInt(row.qty, 10) || 0,
          parseFloat(row.unit_amount) || 0,
          parseFloat(row.monthly_total) || 0
        ]);
      }
    }
    if (!table.length) {
      table = FALLBACK_PRICE_TABLE.slice();
    }
    return {
      cockpitMonthly: parseFloat(meta.cockpit_monthly) || FALLBACK_COCKPIT_MONTHLY,
      freeMonths: parseInt(meta.free_months, 10) || FALLBACK_FREE_MONTHS,
      enterpriseThreshold: parseInt(meta.enterprise_threshold, 10) || FALLBACK_ENTERPRISE_THRESHOLD,
      table: table
    };
  }

  function findPricingRow(table, boatCount) {
    var candidate = table[0];
    for (var i = 0; i < table.length; i++) {
      if (table[i][0] === boatCount) return table[i];
      if (table[i][0] <= boatCount) candidate = table[i];
    }
    return candidate;
  }

  function annualPricePerBoat(monthlyPerBoat, freeMonths) {
    return Math.floor((monthlyPerBoat * (12 - freeMonths)) / 12);
  }

  function calculatePricing(boatCount, cfg) {
    var count = Math.max(1, Math.floor(boatCount) || 1);
    var isEnterprise = count > cfg.enterpriseThreshold;

    if (isEnterprise) {
      return { boatCount: count, isEnterprise: true };
    }

    var row = findPricingRow(cfg.table, count);
    var baseMonthlyPerBoat = row[2] / count;

    return {
      boatCount: count,
      isEnterprise: false,
      cockpit: {
        perBoat: cfg.cockpitMonthly,
        quarterlyTotal: cfg.cockpitMonthly * count * 3,
        annualTotal: annualPricePerBoat(cfg.cockpitMonthly, cfg.freeMonths) * 12 * count
      },
      base360: {
        perBoat: Math.round(baseMonthlyPerBoat),
        quarterlyTotal: row[2] * 3,
        annualTotal: annualPricePerBoat(baseMonthlyPerBoat, cfg.freeMonths) * 12 * count
      }
    };
  }

  function displayPrice(product, period, boatCount) {
    if (period === 'quarterly') {
      return { perBoat: product.perBoat, total: product.quarterlyTotal };
    }
    return {
      perBoat: boatCount > 0 ? Math.floor(product.annualTotal / (12 * boatCount)) : 0,
      total: product.annualTotal
    };
  }

  function formatNumber(n) {
    return n.toLocaleString('en-US');
  }

  function firstYearAmount(amount) {
    return Math.round(Number(amount) * FIRST_YEAR_OFF);
  }

  function init() {
    var section = document.querySelector('[data-nq-pricing]');
    if (!section) return;

    var cfg = buildConfig(parseCatalog(section));

    var boatsInput = section.querySelector('[data-nq-boats-input]');
    var decBtn = section.querySelector('[data-nq-boats-dec]');
    var incBtn = section.querySelector('[data-nq-boats-inc]');
    var periodBtns = section.querySelectorAll('[data-nq-period]');

    var state = { boats: 10, period: 'quarterly' };
    if (boatsInput) {
      var initial = parseInt(boatsInput.value, 10);
      if (initial > 0) state.boats = initial;
    }

    function setConditionalFeatures(card, items) {
      var list = card.querySelector('.nq-price-card__features ul');
      if (!list) return;
      var existing = list.querySelectorAll('[data-nq-conditional]');
      for (var i = 0; i < existing.length; i++) {
        existing[i].parentNode.removeChild(existing[i]);
      }
      items.forEach(function (text) {
        var li = document.createElement('li');
        li.setAttribute('data-nq-conditional', '');
        li.textContent = text;
        list.appendChild(li);
      });
    }

    function renderCard(key, pricing) {
      var card = section.querySelector('[data-nq-card="' + key + '"]');
      if (!card) return;

      var priceBlock = card.querySelector('[data-nq-price-block]');
      var enterpriseBlock = card.querySelector('[data-nq-enterprise]');

      if (pricing.isEnterprise) {
        if (priceBlock) priceBlock.hidden = true;
        if (enterpriseBlock) enterpriseBlock.hidden = false;
        return;
      }

      if (priceBlock) priceBlock.hidden = false;
      if (enterpriseBlock) enterpriseBlock.hidden = true;

      var product = key === 'cockpit' ? pricing.cockpit : pricing.base360;
      var display = displayPrice(product, state.period, pricing.boatCount);
      var promo = {
        perBoat: firstYearAmount(display.perBoat),
        total: firstYearAmount(display.total)
      };

      var perBoatEl = card.querySelector('[data-nq-per-boat]');
      var perBoatListEl = card.querySelector('[data-nq-per-boat-list]');
      var totalEl = card.querySelector('[data-nq-total]');
      var totalListEl = card.querySelector('[data-nq-total-list]');
      var periodLabelEl = card.querySelector('[data-nq-period-label]');
      if (perBoatEl) perBoatEl.textContent = String(promo.perBoat);
      if (perBoatListEl) perBoatListEl.textContent = String(display.perBoat);
      if (totalEl) totalEl.textContent = formatNumber(promo.total);
      if (totalListEl) totalListEl.textContent = formatNumber(display.total);
      if (periodLabelEl) {
        periodLabelEl.textContent = state.period === 'quarterly' ? _('quarter') : _('year');
      }

      var wlEl = card.querySelector('[data-nq-whitelabel]');
      if (wlEl) {
        if (state.period === 'annual') {
          wlEl.textContent = key === 'cockpit' ? _('White-label setup included') : _('Basic white-label setup included');
        } else {
          wlEl.textContent = _('White-label setup discussed case-by-case');
        }
      }

      var conditional = pricing.boatCount < 10
        ? [
          _('One B2B integration included; second integration €500 setup fee'),
          _('Connecting to payment provider €500 setup fee')
        ]
        : [_('Both B2B (Nausys & MMK) integrations and payment connection included')];
      setConditionalFeatures(card, conditional);
    }

    function render() {
      var pricing = calculatePricing(state.boats, cfg);
      renderCard('cockpit', pricing);
      renderCard('base360', pricing);
    }

    function setBoats(value) {
      state.boats = Math.max(1, Math.floor(value) || 1);
      if (boatsInput) boatsInput.value = String(state.boats);
      render();
    }

    if (decBtn) {
      decBtn.addEventListener('click', function () {
        setBoats(state.boats - 1);
      });
    }

    if (incBtn) {
      incBtn.addEventListener('click', function () {
        setBoats(state.boats + 1);
      });
    }

    if (boatsInput) {
      boatsInput.addEventListener('input', function () {
        setBoats(parseInt(boatsInput.value, 10));
      });
    }

    for (var i = 0; i < periodBtns.length; i++) {
      periodBtns[i].addEventListener('click', function () {
        state.period = this.getAttribute('data-nq-period');
        for (var j = 0; j < periodBtns.length; j++) {
          periodBtns[j].classList.toggle('nq-active', periodBtns[j] === this);
        }
        render();
      });
    }

    render();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
